import React, { Fragment } from "react";
import { Instagram, Linkedin, Facebook, Tiktok, EnvelopeAtFill, GeoAltFill, BuildingFillGear, BuildingFill } from 'react-bootstrap-icons';
import { Link } from "react-router-dom";
import Tippy from '@tippyjs/react';
import styles from '../../assets/css/module/common/common.module.css';
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  function mailto(x) {
    window.location.href = `mailto:${x}`;
  }
  function openMap(x) {
    switch (x) {
      case 'HO':
        window.open('https://maps.app.goo.gl/eW2rzX2e6PQKuSrh8');
        break;
      case 'AMO':
        window.open('https://maps.app.goo.gl/ARhrdRnMhRGc8jmz5');
        break;
    }

  }
  return (
    <Fragment>
      <footer className={`${styles["footer"]}`}>
        <div className={`${styles["layout-center"]}`}>
          <div className={`${styles["footer-content"]}`}>
            <div className={`${styles["col-30"]} ${styles["footer-column"]}`}>
              <span className={`${styles["footer-col-title"]}`}>{t('services')}</span>
              <ul>
                <li><Link to={'/services/svc-1'}>{t('svc_1')}</Link></li>
                <li><Link to={'/services/svc-2'}>{t('svc_2')}</Link></li>
                <li><Link to={'/services/svc-3'}>{t('svc_3')}</Link></li>
                <li><Link to={'/services/svc-4'}>{t('svc_4')}</Link></li>
              </ul>
            </div>
            <div className={`${styles["col-20"]} ${styles["footer-column"]}`}>
              <span className={`${styles["footer-col-title"]}`}>{t('sitemap')}</span>
              <ul>
                <li><Link to={'/home'}>{t('home')}</Link></li>
                <li><Link to={'/news'}>{t('news')}</Link></li>
                <li><Link to={'/career'}>{t('career')}</Link></li>
                <li><Link to={'/faq'}>FAQ</Link></li>
                <li><Link to={'/about'}>{t('about_us')}</Link></li>
              </ul>
            </div>
            <div className={`${styles["col-20"]} ${styles["footer-column"]}`}>
              <span className={`${styles["footer-col-title"]}`}>{t('general')}</span>
              <ul>
                <li><Link to={'/fleets'}>{t('Our Fleets')}</Link></li>
                <li><Link to={'/news'}>{t('news')}</Link></li>
              </ul>
            </div>
            <div className={`${styles["col-40"]} ${styles["footer-column"]}`}>
              <div className={`${styles["footer-sub-col-container"]}`}>
                <div className={`${styles["footer-column"]} ${styles["footer-sub-col"]}`}>
                  <span className={`${styles["footer-col-title"]}`}>{t('Contact Us')}</span>
                  <ul>
                    <li>
                      <div className={`${styles["contact-us-detail"]}`}>
                        <div className={`${styles["icon-container"]}`}><EnvelopeAtFill /></div>
                        <div onClick={e => mailto('info@smartaviation.co.id')}>info@smartaviation.co.id</div>
                      </div>
                    </li>
                    <li>
                      <div className={`${styles["contact-us-detail"]}`}>
                        <div className={`${styles["icon-container"]}`}><BuildingFill /></div>
                        <div onClick={e => openMap('HO')}>
                          <div>Head Office</div>
                          Jl. Pantai Indah Selatan I, No.4, RT.4/RW.3, Kamal Muara, Kec. Penjaringan, Jakarta Utara, Daerah Khusus Ibukota Jakarta 14460
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className={`${styles["contact-us-detail"]}`}>
                        <div className={`${styles["icon-container"]}`}><BuildingFillGear /></div>
                        <div onClick={e => openMap('AMO')}>
                          <div>AMO</div>
                          WH.ES 28 dan WH.ES 30, Aeropolis Techno Park, Jl. Marsekal Suryadarma, Neglasari, Kec. Neglasari, Kota Tangerang, Banten 15129
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className={`${styles["footer-column"]} ${styles["sosmed-sec"]}`}>
                  <span className={`${styles["footer-col-title"]}`}>{t('Follow Us')}</span>
                  <div className={`${styles["sosmed-container"]}`}>
                    <Tippy content="Facebook" placement="bottom">
                      <Link to={'https://www.facebook.com/Smart.cakrawala.aviation'} target="_blank"><Facebook className={`${styles["sosmed-icon"]}`} /></Link>
                    </Tippy>
                    <Tippy content="Instagram" placement="bottom">
                      <Link to={'https://instagram.com/smart.cakrawala.aviation'} target="_blank"><Instagram className={`${styles["sosmed-icon"]}`} /></Link>
                    </Tippy>
                    <Tippy content="Tiktok" placement="bottom">
                      <Link to={'https://www.tiktok.com/@smartaviationjourney'} target="_blank"><Tiktok className={`${styles["sosmed-icon"]}`} /></Link>
                    </Tippy>
                    <Tippy content="Linkedin" placement="bottom">
                      <Link to={'https://id.linkedin.com/company/pt-smart-cakrawala-aviation'} target="_blank"><Linkedin className={`${styles["sosmed-icon"]}`} /></Link>
                    </Tippy>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={`${styles["footer-copyright"]}`}>
          Copyright © PT. Smart Cakrawala Aviation
        </div>
      </footer>

    </Fragment>
  )
}

export default Footer;